import "./SecurityApproach.css";
import { useState, useEffect } from "react";

export default function SecurityApproach() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const devopsCapabilities = [
    {
      id: 1,
      title: "Infrastructure as Code (IaC)",
      description:
        "Evaluate security posture, identify risks, and assess compliance gaps across applications, infrastructure, and DevOps workflows.",
    },
    {
      id: 2,
      title: "Infrastructure as Code (IaC)",
      description:
        "Define security policies and select DevSecOps tools aligned with regulatory requirements and operational needs.",
    },
    {
      id: 3,
      title: "Infrastructure as Code (IaC)",
      description:
        "Integrate security scanning, compliance checks, and controls into CI/CD pipelines for continuous protection.",
    },
    {
      id: 4,
      title: "Infrastructure as Code (IaC)",
      description:
        "Continuously monitor security events and enable rapid incident detection, response, and remediation.",
    },
    {
      id: 5,
      title: "Infrastructure as Code (IaC)",
      description:
        "Regularly audit systems, refine security controls, and improve compliance readiness across evolving environments.",
    },
  ];

  const getCardsPerSlide = () => {
    if (window.innerWidth <= 576) return 1;
    if (window.innerWidth <= 1024) return 2;
    return 1;
  };

  const getTransformPercentage = () => {
    if (window.innerWidth <= 576) return 100;
    if (window.innerWidth <= 1024) return 50;
    return 100;
  };

  const [cardsPerSlide, setCardsPerSlide] = useState(getCardsPerSlide());
  const [transformPercentage, setTransformPercentage] = useState(getTransformPercentage());

  const maxSlide = Math.ceil(devopsCapabilities.length / cardsPerSlide) - 1;

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev >= maxSlide ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev <= 0 ? maxSlide : prev - 1));
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    const handleResize = () => {
      const newCardsPerSlide = getCardsPerSlide();
      const newTransformPercentage = getTransformPercentage();
      setCardsPerSlide(newCardsPerSlide);
      setTransformPercentage(newTransformPercentage);
      setCurrentSlide(0);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div id="security-approach" className="outsourcemainclass">
      <h1 className="heading">Our Configuration Management Capabilities</h1>
      <p className="subheading">
        Ensuring Consistency, Control, and Automation Across Environments
      </p>

      <div className="cards card1">
        {devopsCapabilities.slice(0, 3).map((capability) => (
          <div key={capability.id} className="card">
            <h3>{capability.title}</h3>
            <p>{capability.description}</p>
          </div>
        ))}
      </div>

      <div className="cards card2">
        {devopsCapabilities.slice(3, 5).map((capability) => (
          <div key={capability.id} className="card">
            <h3>{capability.title}</h3>
            <p>{capability.description}</p>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <button className="carousel-btn prev-btn" onClick={prevSlide}>
          ‹
        </button>
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentSlide * transformPercentage}%)` }}
          >
            {Array.from({
              length: Math.ceil(devopsCapabilities.length / cardsPerSlide),
            }).map((_, slideIndex) => (
              <div key={slideIndex} className="carousel-slide">
                {devopsCapabilities
                  .slice(
                    slideIndex * cardsPerSlide,
                    slideIndex * cardsPerSlide + cardsPerSlide,
                  )
                  .map((capability) => (
                    <div key={capability.id} className="carousel-card">
                      <h3>{capability.title}</h3>
                      <p>{capability.description}</p>
                    </div>
                  ))}
              </div>
            ))}
          </div>
        </div>
        <button className="carousel-btn next-btn" onClick={nextSlide}>
          ›
        </button>
        <div className="carousel-dots">
          {Array.from({
            length: Math.ceil(devopsCapabilities.length / cardsPerSlide),
          }).map((_, index) => (
            <button
              key={index}
              className={`dot ${currentSlide === index ? "active" : ""}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}